import { Nav, NavItem, NavLink } from "reactstrap";
import { SHIPPING_NAV_DATA } from "../../../../Data/FormLayout";
import { NavComponentProp } from "../../../../Type/FormLayoutType";
import { H6 } from "../../../../AbstractElements";

const NavComponent = ({ callbackActive, activeTab }: NavComponentProp) => {
  const handleTab = (id: number | undefined) => {
    if (id !== undefined) {
      callbackActive(id);
    }
  };
  
  return (
    <Nav className="nav-pills horizontal-options shipping-options">
      {SHIPPING_NAV_DATA.map((data, index) => (
        <NavItem className="w-100" key={index}>
          <NavLink
            className={`b-r-0 ${activeTab === index + 1 ? "active" : ""}`}
            onClick={() => handleTab(data.activeTab)}
          >
            <div className="cart-options">
              <div className="stroke-icon-wizard">
                <i className={`fa ${data.iconClassName}`} />
              </div>
              <div className="cart-options-content">
                <H6>{data.tittle}</H6>
              </div>
            </div>
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default NavComponent;
